import React from 'react';

import { Modal, ModelHeader, ModalBody, ModalFooter } from '../../common/input/modal/Modal';
import logoimg from '../../assets/images/logo.png';

const MainAuthModalView = (props) => {
    return (
        <>
            <Modal className="price-calculator-popup" show={props.modal_show} onHide={props.hideCustomModal}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="price-calculator-pop-cont-wrap">
                                <ModelHeader>
                                    <div className="price-calculator-pop-header">
                                        <h4>Alert !!</h4>
                                    </div>
                                </ModelHeader>
                                <ModalBody>
                                    <div style={{textAlign:"center",padding:'20px'}} className="red-price-box">
                                       <div className="login-form">
                                <h1 style={{textAlign:'center',color: 'white'}}>CountDown</h1>
                                <h2 style={{textAlign:'center',color: 'black'}}>{props.timeleft.days}<span style={{color:'white'}}>d </span>{props.timeleft.hours}<span style={{color:'white'}}>h </span>{props.timeleft.minutes}<span style={{color:'white'}}>m </span>{props.timeleft.seconds}<span style={{color:'white'}}>s </span></h2>
                                    {props.seconds != 0 ?
                                    <form>
                                        <div className="field-box">
                                            <input type="password" name="password" onChange={(e) => props.handelValue(e.target.value)}/>
                                        </div>
                                        <div className="field-box">
                                            <button onClick={props.handelSummit} type="button">Enter Your Pin <i className="fa fa-sign-in"></i></button>
                                        </div>
                                    </form>
                                    :
                                    null
                                }

                                </div>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <div className="wage-pop-footer">
                                        <div className="logo"><img src={logoimg} alt="" /></div>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default MainAuthModalView;